<template>
  <div class="a4" style="padding: 80px 80px; box-sizing: border-box;">

  </div>
</template>
<script>
export default {
  props: {
    header: Object,
    board: Object,
    value: Object,
  },
  computed: {
  },
  methods: {
  }
}
</script>
